import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

import Loading from "../../components/shared/Loading";
import PageContainer from "../../components/template/PageContainer";
import { requireCompanyRole } from "../../router/auth";
import type { RouteMetadata } from "../../router/metadata";

const Screen = lazy(() => import("../../views/company-members"));

export const Route = createFileRoute("/_protected/members")({
  component: RouteComponent,
  beforeLoad: ({ context }) =>
    requireCompanyRole(context.authSnapshot, "Owner"),
  staticData: {
    routeKey: "company-members",
    access: "protected",
    layout: "modern",
    container: "default",
    requiredRoles: [],
    requiredCompanyRole: "Owner",
  } satisfies RouteMetadata,
});

function RouteComponent() {
  return (
    <Suspense fallback={<Loading loading={true} />}>
      <PageContainer
        pageContainerType={Route.options.staticData?.container}
        footer={Route.options.staticData?.footer}
      >
        <Screen />
      </PageContainer>
    </Suspense>
  );
}
